module.exports = __webpack_public_path__ + "img/NoAgent-th.c5f1852.png";